import React from 'react';
import AgentsPreview from './Components/Container/AgentsPreview/AgentsPreview';

const Agents = () => (
  <AgentsPreview />
);

export default Agents;
